"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOutputFileExtension = exports.hasEncryptionConfig = exports.isDerivedTapeType = exports.isRawTapeType = exports.isTapeBuilderNativeOperationType = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
var registry_1 = require("./uiNodes/registry");
Object.defineProperty(exports, "isTapeBuilderNativeOperationType", { enumerable: true, get: function () { return registry_1.isTapeBuilderNativeOperationType; } });
const RawTapeTypes = [
    'rawLoanTape',
    'rawCashBalanceFeed',
    'rawRepaymentTape',
    'rawSupplementalTape',
    'rawReceivableDocumentation',
];
const DerivedTapeTypes = [
    'intermediateTape',
    'generatedLoanTape',
    'generatedCashBalanceFeed',
    'generatedRepaymentTape',
    'generatedSupplementalTape',
];
const isRawTapeType = (type) => RawTapeTypes.includes(type);
exports.isRawTapeType = isRawTapeType;
const isDerivedTapeType = (type) => DerivedTapeTypes.includes(type);
exports.isDerivedTapeType = isDerivedTapeType;
const hasEncryptionConfig = (config) => {
    return (config.encryptionConfig &&
        finley_types_1.typeguards.isEncryptionConfig(config.encryptionConfig));
};
exports.hasEncryptionConfig = hasEncryptionConfig;
const hasOutputFileExtension = (config) => common_1.borrowingBasePipeline.isSupportedFileExtension(config.outputFileExtension);
exports.hasOutputFileExtension = hasOutputFileExtension;
//# sourceMappingURL=consts.js.map